import { render } from "./OptionalText.vue?vue&type=template&id=1609dc62"
import script from "./OptionalText.vue?vue&type=script&lang=js"
export * from "./OptionalText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__